(function() {
  const KEYCODE = {
    SPACE: 32,
    ENTER: 13,
  };

  const compbutton = document.createElement('template');
  compbutton.innerHTML = `
    <style>
      :host {
        display: inline-block;
      }
      :host([hidden]) {
        display: none;
      }
    </style>
    <slot></slot>
  `;

  /*
   https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
   no storage, no comparing
  */
  const storageAvailable = function(type) {
    let storage;
    try {
      storage = window[type];
      const x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return e instanceof DOMException && (
        e.code === 22 ||
        e.code === 1014 ||
        e.name === 'QuotaExceededError' ||
        e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        (storage && storage.length !== 0);
    }
  }

  class CompareToggle extends HTMLElement {
    static get observedAttributes() {
      return ['pressed', 'disabled'];
    }

    constructor() {
      super();
      this.attachShadow({mode: 'open'}); // can't think of anything to do with shadow
      this.shadowRoot.appendChild(compbutton.content.cloneNode(true));
    }

    connectedCallback() {
      if(storageAvailable('localStorage')) {
        if (!this.hasAttribute('role')) { this.setAttribute('role', 'button'); }
        if (!this.hasAttribute('tabindex')) { this.setAttribute('tabindex', 0); }
        if (!this.hasAttribute('aria-pressed')) { this.setAttribute('aria-pressed', 'false'); }

        this._upgradeProperty('pressed');
        this._upgradeProperty('disabled');

        this.addEventListener('keydown', this._onKeyDown);
        this.addEventListener('click', this._onClick);
        this.checkstate();
      } else {
        this.setAttribute('hidden', '');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('keydown', this._onKeyDown);
      this.removeEventListener('click', this._onClick);
    }

    attributeChangedCallback(name, oldValue, newValue) {
      const hasValue = newValue !== null;
      switch (name) {
        case 'pressed':
          this.setAttribute('aria-pressed', hasValue);
          break;
        case 'disabled':
          this.setAttribute('aria-disabled', hasValue);
          if (hasValue) {
            this.removeAttribute('tabindex');
           this.blur();
          } else {
            this.setAttribute('tabindex', '0');
          }
          break;
      }
    }

    adoptedCallback() { }

    _upgradeProperty(prop) {
      if (this.hasOwnProperty(prop)) {
        let value = this[prop];
        delete this[prop];
        this[prop] = value;
      }
    }

    _onKeyDown(event) {
      if (event.altKey){ return; }

      switch (event.keyCode) {
        case KEYCODE.SPACE:
        case KEYCODE.ENTER:
          event.preventDefault();
          this._togglePressed();
          break;
        default:
          return;
      }
    }

    _onClick(event) {
      this._togglePressed();
    }

    _togglePressed() {
      if (this.disabled) { return; }

      this.pressed = !this.pressed;
      this.dispatchEvent(new CustomEvent('compare-change', {
        detail: {
          pressed: this.pressed,
        },
        bubbles: true,
      }));

      if(this.pressed) {
        this.saveCompareItem();
      } else {
        this.removeCompareItem();
      }
      this.attachCompareAccordion();
    }
    
    trackCheckbox(title = '') {
      window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'compare_checkbox',
            product_name: title,
            product_type: window.advertGroup,
            product_category: window.productType,
            page_url: window.location.href
          });
    }
    
    saveCompareItem() {
      if(this.cartsize() < 4) {
        let comparables = this.saveditems();
        if(!comparables[this.itemid]) {
          this.getItemInfo(this.itemid)
          .then((data) => {
            this.trackCheckbox(data.title);
            comparables[this.itemid] = data;
            localStorage.setItem('compares', JSON.stringify(comparables));
            this.comparecart.additem(this.itemid);
          });
        }
      }
    }

    removeCompareItem() {
      let comparables = this.saveditems();
      delete comparables[this.itemid];
      localStorage.setItem('compares', JSON.stringify(comparables));
      this.comparecart.removeitem(this.itemid);
    }

    checkstate() {
      if(Object.keys(this.saveditems()).indexOf(this.itemid) > -1) {
        this.setAttribute('pressed', '');
        this.attachCompareAccordion();
      } else if(this.cartsize() > 3) {
        this.setAttribute('disabled','');
      }

    }

    attachCompareAccordion() {
      if(document.querySelector('#compareable') == null) {
        document.querySelector('body').appendChild(comparecartbox.content.cloneNode(true));
      }
    }

    saveditems() {
      return JSON.parse(localStorage.getItem('compares')) || {};
    }

    cartsize() {
      return Object.keys(this.saveditems()).length;
    }

    async getItemInfo(item) {
      const response = await fetch('https://catalog.avalonflooring.com/catalog/item/'+item, {
        method: 'GET',
        mode: 'cors',
        cache: 'no-cache',
        credentials: 'same-origin',
        redirect: 'follow',
        referrerPolicy: 'same-origin'
      });
      if(!response.ok) {
        throw new Error('form submission failed');
      }
      return response.json();
    }

    assign(product_id, variant_id, handle) {
      this.dataset.productId = product_id;
      this.dataset.variantId = variant_id;
      this.dataset.handle = handle;
    }

    set pressed(value) {
      const isPressed = Boolean(value);
      if (isPressed) {
        this.setAttribute('pressed', '');
      } else {
        this.removeAttribute('pressed');
      }
    }

    get pressed() {
      return this.hasAttribute('pressed');
    }

    set disabled(value) {
      const isDisabled = Boolean(value);
      if (isDisabled) {
        this.setAttribute('disabled', '');
      } else {
        this.removeAttribute('disabled');
      }
    }

    get disabled() {
      return this.hasAttribute('disabled');
    }

    get itemid() {
      return this.dataset.productId + ":" + this.dataset.variantId;
    }

    get productid() {
      return this.dataset.productId;
    }

    get variantid() {
      return this.dataset.variantId;
    }

    get comparecart() {
      return document.querySelector('#compareable');
    }
  }
    
  window.customElements.define('compare-toggle', CompareToggle);

  const comparecartbox = document.createElement('template');
  comparecartbox.innerHTML = `
    <compare-cart class="accordion accordion-flush" id="compareable">
      <div class="accordion-item">
        <h2 class="accordion-header" id="compareable-header">
          <button id="compare_accordion" onclick="popupClicked()" class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#compareable-body" aria-expanded="false" aria-controls="flush-collapseOne">
            Compare Products (<span id="compare-size"></span>/4)
          </button>
        </h2>
        <div id="compareable-body" class="accordion-collapse collapse" aria-labelledby="compareable-header" data-bs-parent="#compareable">
          <div class="compareable-body-cart accordion-body container row">
            <div class="compare-items container row col-md-10">
            </div>
            <div class="compare-actions col-md-2">
              <button onclick="compareClicked()" id="compare-show" class="btn btn-primary">Compare</button>
              <button id="compare-clear" class="btn btn-link">Clear All</button>
            </div>
          </div>
        </div>
      </div>
    </compare-cart>
  `;
  const comparecartitem = document.createElement('template');
  comparecartitem.innerHTML = `
    <div class="compareitem col-md-3">
      <div class="btn-close-wrapper"><button type="button" class="btn-close btn-close-white compareitem-remove" aria-label="Close"></button></div>
      <div class="compareitem-image"><img src=""></div>
      <div class="compareitem-title"></div>
      <div class="compareitem-subtitle"></div>
    </div>
  `;

  class CompareCart extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let items = Object.keys(this.saveditems);
      items.forEach((item) => { this.additem(item); });
      this.clearall_ev = this.clearall.bind(this);
      this.showcompare_ev = this.showcompare.bind(this);
      this.querySelector('#compare-clear').addEventListener('click', this.clearall_ev);
      this.querySelector('#compare-show').addEventListener('click', this.showcompare_ev);
    }

    disconnectedCallback() {
      this.querySelector('#compare-clear').removeEventListener('click', this.clearall_ev);
      this.querySelector('#compare-show').removeEventListener('click', this.showcompare_ev);
    }

    additem(item) {
      let data = this.saveditems[item];
      let newitem = comparecartitem.content.cloneNode(true);
      newitem.querySelector('.compareitem').setAttribute('id', 'cc-' + item.replace(':','-'));
      newitem.querySelector('.compareitem-remove').setAttribute('data-cid', item)
      newitem.querySelector('.compareitem-remove').addEventListener('click', () => { this.clearone(item); })
      let tempimage = data.image.split('.');
      tempimage[tempimage.length - 2] = tempimage[tempimage.length - 2] + '_300x300_crop_center';
      newitem.querySelector('.compareitem-image img').setAttribute('src', tempimage.join('.'));
      newitem.querySelector('.compareitem-title').innerHTML = data.title;
      newitem.querySelector('.compareitem-subtitle').innerHTML = data.color;
      this.body.appendChild(newitem);
      this._updatelabel();
      this._manageButtons();
    }

    showcompare() {
      if(!document.querySelector('#comparemodal')) {
        let modal_el = comparemodal.content.cloneNode(true);
        let modal = Array.from(modal_el.children)[0]; // save node reference
        document.querySelector('body').appendChild(modal_el);
        Object.keys(this.saveditems).forEach((item) => {
          let card_el = comparemodalcard.content.cloneNode(true);
          let card = Array.from(card_el.children)[0]; // save node reference
          modal.querySelector('.modal-body').appendChild(card_el);
          card.populate_with(this.saveditems[item]);
        });

        document.querySelector('body').classList.add('full_modal');
      }
    }

    clearone(item) {
      let [pid, vid] = item.split(':');
      if(document.querySelector('compare-toggle[data-product-id="'+pid+'"][data-variant-id="'+vid+'"]')) {
        document.querySelector('compare-toggle[data-product-id="'+pid+'"][data-variant-id="'+vid+'"]')._togglePressed();
      } else {
        document.querySelector('#compareable').removeitem(item);
      }
    }

    clearall() {
      Object.keys(this.saveditems).forEach((item) => {
        this.clearone(item);
      });
    }

    removeitem(item) {
      if(this.cartsize == 0) {
        setTimeout((f) => { document.querySelector('#compareable').remove(); }, 150);
      } else {
        let comparables = this.saveditems;
        delete comparables[item];
        localStorage.setItem('compares', JSON.stringify(comparables));
        this.body.querySelector('#cc-' + item.replace(':','-')).remove();
        this._updatelabel();
        this._manageButtons();
      }
    }

    get cartsize() {
      return Object.keys(this.saveditems).length;
    }

    get saveditems() {
      return JSON.parse(localStorage.getItem('compares')) || {};
    }

    get body() {
      return this.querySelector('#compareable-body div.compare-items');
    }

    _updatelabel() {
      document.querySelector('#compare-size').innerHTML = this.cartsize;
    }

    _manageButtons() {
      if(this.cartsize == 1) { this.querySelector('#compare-show').setAttribute('disabled', ''); }
      else { this.querySelector('#compare-show').removeAttribute('disabled'); }

      if(this.cartsize > 3) { document.querySelectorAll('compare-toggle:not([pressed])').forEach((i) => { i.setAttribute('disabled', ''); }); }
      if(this.cartsize <= 3) { document.querySelectorAll('compare-toggle[disabled]').forEach((i) => { i.removeAttribute('disabled'); }); }
    }
  }
  window.customElements.define('compare-cart', CompareCart);

  const comparemodal = document.createElement('template');
  comparemodal.innerHTML = `
    <compare-modal id="comparemodal" class="modal show focus" tabindex="-1" style="display:block">
      <div class="compare-modal-dialog modal-dialog modal-fullscreen">
        <div class="compare-modal-content modal-content carousel carousel carousel-dark">
          <div class="compare-modal-header modal-header">
            <button type="button" class="btn btn-primary closer" aria-label="Close">back to products</button>
            <h2 class="compare-modal-title modal-title">Compare</h2>
          </div>
          <div class="compare-modal-body modal-body row carousel-inner">

          </div>
          <button class="carousel-control-prev" type="button" data-bs-target=".compare-modal-content" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target=".compare-modal-content" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>
      </div>
    </compare-modal>
  `;
  class CompareModal extends HTMLElement{
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelector('.compare-modal-header > button.closer').addEventListener('click', this.teardown);
    }

    disconnectedCallback() {
      document.querySelector('body').classList.remove('full_modal');
      this.querySelector('.compare-modal-header > button.closer').removeEventListener('click', this.teardown);
    }

    teardown() {
      document.querySelector('#comparemodal').remove();
    }
  }
  window.customElements.define('compare-modal', CompareModal);

  const comparemodalcard = document.createElement('template');
  comparemodalcard.innerHTML = `
    <compare-modal-card class="compare-modal-card card col-md-3 carousel-item">
      <div class="ratio ratio-1x1">
        <img src="" class="card-img-top" alt="">
      </div>
      <div class="card-body">
        <h5 class="card-title"></h5>
        <h5 class="card-subtitle"></h5>
        <div class="props row-cols-2 row">
          <span class="col compare-modal-card-label">Price</span>
          <span class="col compare-modal-card-value compare-modal-card-price"></span>
          <span class="col compare-modal-card-label">SKU</span>
          <span class="col compare-modal-card-value compare-modal-card-sku"></span>
          <span class="col compare-modal-card-label">Size</span>
          <span class="col compare-modal-card-value compare-modal-card-size"></span>
          <span class="col compare-modal-card-label">Coverage</span>
          <span class="col compare-modal-card-value compare-modal-card-coverage"></span>
          <span class="col compare-modal-card-label">Color</span>
          <span class="col compare-modal-card-value compare-modal-card-color"></span>
        </div>
        <span class="col compare-modal-card-additional"></span>
      </div>
    </compare-modal-card>
  `;
  class CompareModalCard extends HTMLElement {
    constructor() {
      super();
    }

    populate_with(item) {
      if(document.querySelectorAll('compare-modal-card').length == 1) {
        this.classList.add('active');
      }
      let tempimage = item.image.split('.');
      tempimage[tempimage.length - 2] = tempimage[tempimage.length - 2] + '_300x300_crop_center';
      this.querySelector('.card-img-top').src = tempimage.join('.');
      this.querySelector('.card-title').innerHTML = item.title;
      this.querySelector('.compare-modal-card-price').innerHTML = item.price || ' &mdash;';
      this.querySelector('.compare-modal-card-sku').innerHTML = item.sku || ' &mdash;';
      this.querySelector('.compare-modal-card-size').innerHTML = item.size || ' &mdash;';
      this.querySelector('.compare-modal-card-coverage').innerHTML = item.coverage || ' &mdash;';
      this.querySelector('.compare-modal-card-color').innerHTML = item.color || ' &mdash;';
      this.querySelector('.compare-modal-card-additional').innerHTML = item.additional_description || '';
    }
  }
  window.customElements.define('compare-modal-card', CompareModalCard);

  if(storageAvailable('localStorage')) {
    if(localStorage.getItem('compares') != null &&
      Object.keys(JSON.parse(localStorage.getItem('compares'))).length > 0 &&
      document.querySelector('#compareable') == null) {
        document.querySelector('body').appendChild(comparecartbox.content.cloneNode(true));
    }
  }
})();
